package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.Composable
import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.TimeOfDaySelector

@Composable
internal fun TimeOfDaySection(
    selectedValue: HourOfDay?,
    onValueChange: (HourOfDay?) -> Unit,
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
    title: String = "Wybierz czas"
) = EditViewSection(
    enabled = enabled,
    title = title,
    withTitle = false,
) {
    val selectedTimes = if (selectedValue != null) listOf(selectedValue) else emptyList()

    TimeOfDaySelector(
        selectedTimes = selectedTimes,
        onSelectionChange = { times ->
            onValueChange(times.lastOrNull())
        },
        mode = mode,
        enabled = enabled,
    )
}
